import { createContext, useContext, useState } from 'react';

const JobContext = createContext();

export const JobProvider = ({ children }) => {
  const [formData, setFormData] = useState({ permit: {
    companyName: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    telephone: '',
    capsCustRef: '',
    nonProfitAuth: '',
    paymentAccount: '',
    mailerId: '',
    crid: '',
  },
  ncoa:1
});
  const [finalCSV, setFinalCSV] = useState(null); // remapped CSV blob
  const [originalCSVData, setOriginalCSVData] = useState([]); // store original CSV
  const [csvMeta, setCsvMeta] = useState({ name: '', records: 0 });
const [csvMappings, setCsvMappings] = useState(null);

  return (
    <JobContext.Provider
      value={{
        formData,
        setFormData,
        finalCSV,
        setFinalCSV,
        originalCSVData,
        setOriginalCSVData,
        csvMeta,
        setCsvMeta,
          csvMappings,
        setCsvMappings,
      }}
    >
      {children}
    </JobContext.Provider>
  );
};

export const useJobContext = () => useContext(JobContext);
